enum AdminNotificationType {
  ADMIN_USER_SET_INITIAL_PASSWORD = "admin_user_set_initial_password",
  ADMIN_INVENTORY_VEHICLE_ADDED = "admin_inventory_vehicle_added",
  ADMIN_INVENTORY_VEHICLE_DELETED = "admin_inventory_vehicle_deleted",
  ADMIN_INVENTORY_PUBLISHED_ON_SITE_EVENT = "admin_inventory_published_on_site_event",
  ADMIN_INVENTORY_SOLD_EVENT = "admin_inventory_sold_event",
  ADMIN_INVENTORY_PAYOFF_EXPIRING = "admin_inventory_payoff_expiring",
  ADMIN_USER_CREATED_EVENT = "admin_user_created_event",
  ADMIN_APPLICATION_CREATED_EVENT = "admin_application_created_event",
  ADMIN_APPLICATION_STATUS_CHANGE_EVENT = "admin_application_status_change_event",
  ADMIN_LEAD_CREATED_EVENT = "admin_lead_created_event",
  ADMIN_LEAD_SHIPPING_INFORMATION_NEEDED = "admin_lead_shipping_information_needed",
  ADMIN_LEAD_SHIPPING_QUOTE_COMPLETE = "admin_lead_shipping_quote_complete",
  ADMIN_DEAL_CREATED_EVENT = "admin_deal_created_event",
  ADMIN_DEAL_STATUS_CHANGE_EVENT = "admin_deal_status_change_event",
  ADMIN_TRANSPORTER_PHOTOS_COMPLETED = "admin_transporter_photos_completed",
  ADMIN_TRANSPORTER_VEHICLE_READY_FOR_TRANSPORT = "admin_transporter_vehicle_ready_for_transport",
  ADMIN_TRANSPORTER_PACKAGE_COMPLETION_REQUESTED = "admin_transporter_package_completion_requested",
  ADMIN_TRANSPORTER_DRIVER_CREATION_REQUEST = "admin_transporter_driver_creation_request",
  ADMIN_TRANSPORTER_INSPECTION_CHECKLIST_COMPLETED = "admin_transporter_inspection_checklist_completed",
  ADMIN_TRANSPORTER_REPAIR_ESTIMATE_UPLOADED = "admin_transporter_repair_estimate_uploaded",
  ADMIN_TRANSPORTER_REPAIR_TIMELINE_UPDATED = "admin_transporter_repair_timeline_updated",
  ADMIN_TRANSPORTER_SHIPMENT_REJECTED = "admin_transporter_shipment_rejected",
  ADMIN_TRANSPORTER_SLA_OVERDUE_DAILY = "admin_transporter_sla_overdue_daily",
  ADMIN_OVERDUE_VEHICLE_REMINDER = "admin_overdue_vehicle_reminder",
  ADMIN_REPAIR_5_DAYS_REMINDER = "admin_repair_5_days_reminder",
  ADMIN_VEHICLE_PICKUP_LOCATION_NEEDED = "admin_vehicle_pickup_location_needed",
  ADMIN_VEHICLE_PICKUP_LOCATION_COMPLETED = "admin_vehicle_pickup_location_completed",
  ADMIN_VEHICLE_GATE_PASS_NEEDED = "admin_vehicle_gate_pass_needed",
  ADMIN_VEHICLE_PENDING_SALE_TITLE_COPY_NEEDED = "admin_vehicle_pending_sale_title_copy_needed",
  ADMIN_VEHICLE_PENDING_SALE_NOT_PURCHASED = "admin_vehicle_pending_sale_not_purchased",
  ADMIN_VEHICLE_FUNDED_NEEDS_SOLD = "admin_vehicle_funded_needs_sold",
  ADMIN_VEHICLE_PURCHASED_NEEDS_PICKUP_LOCATION = "admin_vehicle_purchased_needs_pickup_location",
  ADMIN_VEHICLE_PAID_FOR_TITLE_REQUEST = "admin_vehicle_paid_for_title_request",
  ADMIN_VEHICLE_FUNDED = "admin_vehicle_funded",
  ADMIN_TITLE_RECEIVED = "admin_title_received",
  ADMIN_TITLE_OVERVIEW = "admin_title_overview",
  ADMIN_TITLE_REMINDER = "admin_title_reminder",
  ADMIN_SOLD_TITLE_IN_TRANSIT_REMINDER = "admin_sold_title_in_transit_reminder",
  ADMIN_ELECTRONIC_TITLE_LIEN_RELEASE_REMINDER = "admin_electronic_title_lien_release_reminder",
  SALES_REP_REPAIR_COMPLETE = "sales_rep_repair_complete",
  SALES_REP_DELIVERY_COMPLETE = "sales_rep_delivery_complete",
  SALES_REP_VEHICLE_FUNDED = "sales_rep_vehicle_funded",
  ADMIN_MANAGEMENT_REPAIR_COMPLETE = "admin_management_repair_complete",
  ADMIN_MANAGEMENT_DELIVERY_COMPLETE = "admin_management_delivery_complete",
  STOCK_NUMBER_PAYOFF_EXPIRING = "stock_number_payoff_expiring",
  STOCK_NUMBER_PICKUP_LOCATION_NEEDED = "stock_number_pickup_location_needed",
  STOCK_NUMBER_GATE_PASS_NEEDED = "stock_number_gate_pass_needed",
  STOCK_NUMBER_PENDING_SALE_TITLE_COPY_NEEDED = "stock_number_pending_sale_title_copy_needed",
  STOCK_NUMBER_PURCHASED_NEEDS_PICKUP_LOCATION = "stock_number_purchased_needs_pickup_location",
  STOCK_NUMBER_TITLE_OVERVIEW = "stock_number_title_overview",
  STOCK_NUMBER_TITLE_REMINDER = "stock_number_title_reminder",
  ADMIN_PART_REQUESTED = "admin_part_requested",
  ADMIN_PTO_REQUEST_CREATED = "admin_pto_request_created",
}

enum TransporterNotificationType {
  TRANSPORTER_PACKAGE_ASSIGNED = "transporter_package_assigned",
  TRANSPORTER_PACKAGE_STATUS_CHANGED = "transporter_package_status_changed",
  TRANSPORTER_VEHICLE_READY_FOR_PICKUP = "transporter_vehicle_ready_for_pickup",
  TRANSPORTER_VEHICLE_MARKED_FOR_REPAIR = "transporter_vehicle_marked_for_repair",
  TRANSPORTER_SHIPMENT_LEG_READY = "transporter_shipment_leg_ready",
  TRANSPORTER_SHIPMENT_LEG_NOT_READY = "transporter_shipment_leg_not_ready",
  TRANSPORTER_SHIPMENT_LEG_DROPOFF_CHANGED = "transporter_shipment_leg_dropoff_changed",
  TRANSPORTER_SHIPMENT_LEG_COMPANY_ASSIGNED = "transporter_shipment_leg_company_assigned",
  TRANSPORTER_SHIPMENT_LEG_MEMBER_ASSIGNED = "transporter_shipment_leg_member_assigned",
  TRANSPORTER_SHIPMENT_LEG_COMPANY_UNASSIGNED = "transporter_shipment_leg_company_unassigned",
  TRANSPORTER_DRIVER_USER_REQUEST_REVIEWED = "transporter_driver_user_request_reviewed",
}

export {
  AdminNotificationType,
  TransporterNotificationType,
};
